// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GcUN","top":"styles_top__2tcPV","left":"styles_left__HNIXF","description":"styles_description__lbm6t"};